"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailValidate = void 0;
function emailValidate(email) {
    /**
     * ローカル部はquoted-string形式やquoted-pair形式は除外。
     * ドメイン名は管理者がユーザー招待時に全角文字と半角文字の打ち間違いする可能性も考慮し、一般的に普及している半角文字列のみを許可
     */
    var reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/;
    return reg.test(email);
}
exports.emailValidate = emailValidate;
